module.exports = __webpack_public_path__ + "img/rideInnovation.c4485cee.jpg";